import { useEffect } from "react";
import { toast } from "react-toastify";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { ADMIN_LEADS_ENDPOINTS, AdminLeadsService } from "@/service/api/admin-leads";
import { ListAdminLeadsDto } from "@/service/dto/admin-leads";

const useLeadsList = (params: ListAdminLeadsDto) => {
  const query = useQuery({
    queryKey: [ADMIN_LEADS_ENDPOINTS.LIST, params],
    queryFn: () => AdminLeadsService.list(params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar leads.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useLeadsList;
